export var AppRoute;
(function (AppRoute) {
    AppRoute["Dashboard"] = "dashboard";
    AppRoute["OrgScopedRegistration"] = "org-scoped-registration";
    AppRoute["UnscopedRegistration"] = "unscoped-registration";
    AppRoute["Admin"] = "admin";
    AppRoute["OrgScopedAuto"] = "org-scoped-auto";
    AppRoute["UnscopedAuto"] = "unscoped-auto";
    AppRoute["VerifyEmail"] = "verify-email";
})(AppRoute || (AppRoute = {}));
//# sourceMappingURL=AppRoute.js.map